
import { defineComponent, onMounted, onUnmounted, ref, type PropType } from 'vue';
import AppDropdownMenu, { DropdownSize } from './DropdownMenu.vue';

type DropdownSizeValue = DropdownSize | `${DropdownSize}`;

export default defineComponent({
    name: 'AppDropdown',
    components: { AppDropdownMenu },
    props: {
        size: {
            type: String as PropType<DropdownSizeValue>,
            default: DropdownSize.Medium
        }
    },
    setup() {
        const dropdownElement = ref<HTMLElement | null>(null);
        const isOpen = ref(false);

        const toggleDropdown = (): void => {
            isOpen.value = !isOpen.value;
        };

        onMounted(() => {
            dropdownElement.value?.addEventListener('click', toggleDropdown);
        });

        onUnmounted(() => {
            dropdownElement.value?.removeEventListener('click', toggleDropdown);
        });

        return {
            dropdownElement,
            isOpen
        };
    }
});
